import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.648 9.242a.75.75 0 0 1-.53-.219L.795 5.705a.75.75 0 1 1 1.06-1.061l2.793 2.789L11.294.796a.75.75 0 1 1 1.061 1.061L5.178 9.024a.75.75 0 0 1-.53.218",
      "data-name": "Path 1489"
    }, null, -1)
  ])))
}
export default { render: render }